import type { ReactNode } from 'react';
import { useIsInDraftMode } from '../hooks/useDraftMode';
import { ReadOnlyProvider } from '../contexts/ReadOnlyContext';

/**
 * Route wrapper: the subtree is read-only whenever the user is in production mode.
 * Edits to these records are rejected by the API outside a draft, so production mode
 * must not look editable.
 *
 * Lives here rather than in ReadOnlyContext because that module is imported by the ui
 * primitives, which must not transitively depend on the auth service.
 */
export function ReadOnlyInProduction({ children }: { children: ReactNode }) {
  const isInDraftMode = useIsInDraftMode();
  return <ReadOnlyProvider readOnly={!isInDraftMode}>{children}</ReadOnlyProvider>;
}
